export default __webpack_public_path__ + "static/media/contacto_2.5b26cf2d.jpeg";